import { Button, Flex, Menu, Pagination } from '@mantine/core';
import React from 'react';
import { HiOutlineChevronDown } from 'react-icons/hi';

export interface DropdownComponent {
  label: string;
  value: number;
}

interface TPaginationProps {
  data: any;
  activePage: number;
  activeSizePage: number;
  sizePage: DropdownComponent[];
  setActivePage: (_data: any) => void;
  setActiveSizePage: (_data: any) => void;
}

const TPagination: React.FC<TPaginationProps> = ({
  activePage,
  activeSizePage,
  data,
  sizePage,
  setActivePage,
  setActiveSizePage
}) => {
  return (
    <Flex justify={'space-between'} align={'center'} wrap={'wrap-reverse'}>
      <Menu trigger='hover' openDelay={100} closeDelay={400}>
        <Menu.Target>
          <Button variant={'outline'} radius='md' rightSection={<HiOutlineChevronDown />}>
            {activeSizePage}
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          {sizePage.map((item, index) => (
            <Menu.Item key={index} onClick={() => setActiveSizePage(item.value)}>
              {item.label}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>

      <Pagination
        total={Math.ceil(data / activeSizePage)}
        value={activePage}
        onChange={setActivePage}
        siblings={1}
      />
    </Flex>
  );
};

export default TPagination;
